module.exports = __webpack_public_path__ + "img/hair_color_redhead.52c017a.svg";